var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfferFood(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.45,
    height: 19.706,
    viewBox: "0 0 32.45 19.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product_Food_Sub_Solid-Icon",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5649",
    "data-name": "Path 5649",
    d: "M39.763,12.93H9.81A6.64,6.64,0,0,1,16.446,6.3h1.134L15.5,9.231a.64.64,0,0,0,.156.884.611.611,0,0,0,.362.112.635.635,0,0,0,.518-.269L19.128,6.28h4.911L21.957,9.212a.63.63,0,0,0,.518.977.64.64,0,0,0,.518-.269L25.588,6.3h4.886L28.4,9.231a.645.645,0,0,0,1.051.748L32.038,6.3h1.095a6.636,6.636,0,0,1,6.631,6.631Z",
    transform: "translate(-8.564 -6.28)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5650",
    "data-name": "Path 5650",
    d: "M39.585,35.052a6.64,6.64,0,0,1-6.176,4.207H15.5A6.645,6.645,0,0,1,9.28,35a3.64,3.64,0,0,0,2.086-1.187c1.124-1.124,3.117-2.341,4.759-.977s3.552,2.7,4.979,1.27,3.088-2.2,5.14-.919,3.6,2.052,4.735.919,3.357-2.248,5.375-.894c0,0,2,1.373,3.42,1.182Z",
    transform: "translate(-8.293 -19.552)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5651",
    "data-name": "Path 5651",
    d: "M38.654,26.461H8.315a1.055,1.055,0,1,1,0-2.111H38.654a1.055,1.055,0,1,1,0,2.111Z",
    transform: "translate(-7.26 -15.52)",
    fill: "#ed8b00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferFood);
export default __webpack_public_path__ + "static/media/offer_food.0b92d83cccdc812e6ff1cb9fc83845a4.svg";
export { ForwardRef as ReactComponent };